import Main from "../components/layout/Main";
import React from "react";
import {Simulations} from "../containers/Simulations/Simulations";

export const SimulationsPage = () => {
    return <Main title="Simulations" showSidebarMenu={false}>
        <Simulations/>
    </Main>
}